import { UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import type { JSX } from 'react';

import * as styles from './DeveloperContactItem.css';

type DeveloperContactItemProps = {
  title: string;
  content: JSX.Element | string;
  testId?: string;
};

export const DeveloperContactItem: React.FC<DeveloperContactItemProps> = ({ title, content, testId }) => {
  return (
    <div className={styles['container']} data-testid={testId}>
      <UIText2 data-testid="title" color="gray60_100">
        {title}
      </UIText2>
      <UIText1 data-testid="content">{content}</UIText1>
    </div>
  );
};
